import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import styled from 'styled-components';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
const Container = styled.div.withConfig({
  displayName: "Separator__Container",
  componentId: "sc-1kq23mv-0"
})(({
  theme
}) => {
  return {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: theme.space['400'],
    '&::before, &::after': {
      content: '""',
      borderTop: `1px solid ${theme.color['border-core-default']}`,
      margin: `0 ${theme.space['400']} 0 0`,
      flex: '1 0 20px'
    },
    '&::after': {
      margin: `0 0 0 ${theme.space['400']}`
    }
  };
});
const Separator = ({
  message
}) => {
  return /*#__PURE__*/_jsx(Container, {
    children: /*#__PURE__*/_jsx(Text, {
      as: "span",
      color: "text-primary-default",
      textAlign: "center",
      typography: "body-200",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: message
      })
    })
  });
};
export default Separator;